<!--  -->
<template>
  <div class="container">
    <div class="top">
      <div class="left">
        <img src="../../assets/image/morentouxiang@2x.png" alt />
      </div>
      <div class="right">
        <div class="company">{{userInfo.company_name}}</div>
        <div class="status">
          <img src="../../assets/image/renzhneg@2x.png" alt /> 已认证
        </div>
      </div>
    </div>
    <div class="title">企业信息</div>
    <div class="item">
      <span class="text">统一社会信用代码</span>
      <span class="number">{{userInfo.company_code}}</span>
    </div>
    <div class="item">
      <span class="text">邮箱地址</span>
      <span class="number">{{userInfo.company_email}}</span>
    </div>
    <button class="relieve" @click="relieveBind()">解除绑定</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userInfo:{}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 获取个人信息
    getUserInfo(){
      this.$http.getUserInfo({}).then(res=>{
        if(res.status == 1){
          this.userInfo = res.data
        }else{
          this.$hide.alert({
            message:res.msg
          })
        }
      })
    },
    // 解除绑定
    relieveBind(){
      this.$hide.confirm({
        message:"确定要解除当前绑定的企业吗"
      }).then(()=>{
        this.$http.confirmUnbindCompany({

        }).then(res=>{
          if(res.status == 1){
            this.$toast.success(res.msg)
          }else{
            this.$hide.alert({
              message:res.msg
            })
          }
        })
      })
      
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUserInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  position: relative;
  .top {
    margin-top: 12px;
    width: 100%;
    padding: 9px 19px;
    box-sizing: border-box;
    background-color: #fff;
    .left {
      display: inline-block;
      width: 69px;
      height: 69px;
      vertical-align: middle;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      display: inline-block;
      vertical-align: middle;
      margin-left: 18px;
      .company {
        font-size: 16px;
        color: #333333;
      }
      .status {
        color: #999999;
        font-size: 13px;
        margin-top: 13px;
        img {
          width: 9px;
          height: 11px;
        }
      }
    }
  }
  .title {
    font-size: 15px;
    color: #999999;
    margin-left: 19px;
    margin-top: 21px;
    margin-bottom: 12px;
  }
  .item {
    width: 100%;
    background-color: #fff;
    padding: 15px 18px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      font-size: 16px;
      color: #333333;
    }
    .number {
      font-size: 16px;
      color: #666666;
    }
  }
  .relieve{
      width: 85%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background-color: #fff;
      color:#FF5521;
      border: none;
      border-radius: 22px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 80px;
      font-size: 17px;
  }
}
</style>